"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _BaseInjectors = require("react-platform-components/dist/BaseComponents/BaseInjectors");
var _Transactions = _interopRequireDefault(require("./Transactions"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * We create out class by using injectToBaseContainer
 * this will return a React Component that is wrapped with the HOCs
 * inside flowRight, and hass all the props that are passed as options
 */
var _default = (0, _BaseInjectors.injectToBaseContainer)(_.flowRight(), {
  listComponent: _Transactions.default,
  // Override componentDidMount because will do our fetching from the
  // Transactions component
  componentDidMount: function componentDidMount() {},
  headerTitle: 'Mes Transactions',
  headerIcon: 'swap_horiz'
});
exports.default = _default;